<template>
    <div>
        <h2 class="text-center mb-6">
            {{ $t(`auth.schoolManager`) }}
        </h2>

        <register-user-form role="school-manager" />

        <CustomButton
            class="mt-6"
            version="text"
            @click.prevent="goBack">
            {{ $t("global.goBack") }}
        </CustomButton>
    </div>
</template>

<script>
import RegisterUserForm from "views/auth/register/RegisterUserForm"
import CustomButton from "components/globals/CustomButton"

export default {
    name: "RegisterInstructionsSchoolManager",
    components: { CustomButton, RegisterUserForm }
}
</script>
